import React from 'react';

import {phoneFormatter, dateFormatter} from '~/utils/formatters'

export default function Input({formatter, value,...rest}){

  return (
     <input
      value={
        formatter === 'cell' || formatter === 'tel'
          ? phoneFormatter(value, formatter === 'cell')
          : formatter === 'date'
            ? dateFormatter(value)
            : value
      }
      {...rest}
     />
  )
}
